<template>
  <div class="calendar-view-selector">
    <div
      v-for="(item, index) in viewModes"
      :key="'calendarViewSelector' + index"
      class="col-sm-4"
      :class="[{ active: item.id == value }]"
      @click="$emit('on-viewmode-changed', item.id)"
    >
      <span>{{ item.name }}</span>
    </div>
  </div>
</template>

<script>
import calendarViewModes from '@/utils/shared/constants/calendarViewModes';

export default {
  name: 'ViewModeSelector',
  props: {
    value: {
      type: Number,
      default: () => calendarViewModes.Month,
    },
  },
  computed: {
    viewModes() {
      return [
        { id: calendarViewModes.Month, name: 'Mes' },
        { id: calendarViewModes.Week, name: 'Semana' },
        { id: calendarViewModes.Day, name: 'Día' },
      ];
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';

.calendar-view-selector {
  display: flex;
  cursor: pointer;
  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    color: map-get($colors, 'gray-7');
    width: 105px;
    height: 38px;

    span {
      user-select: none;
    }

    &.active {
      border-radius: 8px;
      background: map-get($colors, 'orange');
      color: map-get($colors, 'white');
    }
  }
}
</style>
